/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { UserProfileResponse } from '../models/user-profile-response';

/**
 * User management APIs
 */
@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getLoggedInUserDetails()` */
  static readonly GetLoggedInUserDetailsPath = '/api/v1/users/me';

  /**
   * Get logged in user details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLoggedInUserDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoggedInUserDetails$Response(
    params?: {},
    context?: HttpContext
  ): Observable<StrictHttpResponse<UserProfileResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      UserService.GetLoggedInUserDetailsPath,
      'get'
    );
    if (params) {
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<UserProfileResponse>;
        })
      );
  }

  /**
   * Get logged in user details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLoggedInUserDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLoggedInUserDetails(
    params?: {},
    context?: HttpContext
  ): Observable<UserProfileResponse> {
    return this.getLoggedInUserDetails$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<UserProfileResponse>): UserProfileResponse =>
          r.body
      )
    );
  }
}
